import type { PerimeterStreetOrientationTable } from "building-types/planarGraphs/planarGraphAssociationTypes";
import type { PlanarGraphPerimeterInfo } from "building-types/planarGraphs/planarGraphPerimeterInfo";
import type { Table, RWTable } from "common/data/table";

export function coveredPerimeterFacesByLevelLookup(
  planarGraphPerimeters: Table<PlanarGraphPerimeterInfo>,
): Table<PerimeterStreetOrientationTable> {
  const byLevelTable: RWTable<PerimeterStreetOrientationTable> = {};
  for (const levelId in planarGraphPerimeters) {
    byLevelTable[levelId] = planarGraphPerimeters[levelId].coveredPerimeterStreetOrientations;
  }
  return byLevelTable;
}
